// core
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'open-price',
  templateUrl: './open-price.component.html',
  styleUrls: ['./open-price.component.scss']
})
export class OpenPriceComponent implements OnInit {
  @Input() price: any;
  @Input() precision?: number;
  @Input() size?: any;
  format: string = '2-2';
  symbol!: string;

  constructor() { }

  ngOnInit(): void {
    if (this.precision === 0) {
      this.format = '0-0';
    }
  }
}
